import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import customerEnterpriseLayout from '@/customerEnterpriseLayout'
import opennessLayout from "@/opennessLayout/index.vue";

Vue.use(VueRouter)

export const naviRouter = []

export const constantRoutes = [
    {
        path: '/',
        redirect: '/index',
        hidden: true,
        meta: {
            title: '首页',
            hidden: true
        },
    },
    {
        path: '/index',
        component: () => import('@/pages/home/home.vue'),
        hidden: true,
        meta: {
            title: '首页',
            hidden: true
        },
    },
    {
        path: '/notice/detail/:noticeId',
        name: 'NoticeDetail',
        component: () => import('@/pages/home/NewDetail.vue'),
        hidden: true,
    },
    {
        path: '/login',
        component: () => import('@/pages/login/login.vue'),
        hidden: true,
        meta: {
            title: '登录',
            hidden: true
        },
    },
    {
        path: '/error',
        component: () => import('@/pages/home/error.vue'),
        hidden: true,
        meta: {
            hidden: true
        },
    },
    {
        path: '/handwriting',
        component: () => import('@/pages/handWriting/handWriting.vue'),
        hidden: true,
        meta: {
            hidden: true
        },
    },
    {
        path: '/authentication',
        component: () => import('@/pages/authentication/index.vue'),
        hidden: true,
        meta: {
            hidden: true
        },
    },
    {
        path: '/findPassword/findPassword',
        component: () => import('@/pages/findPassword/findPassword.vue'),
        hidden: true,
        meta: {
            title: '找回密码',
            hidden: true
        },
    },
    {
        path: '/register/register',
        component: () => import('@/pages/register/register.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/register/operatorAuthentication',
        component: () => import('@/pages/register/physicsSeal/operatorAuthentication.vue'),
        hidden: true,
        meta: {
            title: '经办人认证',
            hidden: true
        },
    },
    {
        path: '/register/physicsSeal/:id',
        name: '/register/physicsSeal',
        component: () => import('@/pages/register/physicsSeal/physicsSeal.vue'),
        hidden: true,
        meta: {
            title: '物理章申领',
            hidden: true
        },
    },
    {
        path: '/register/success',
        component: () => import('@/pages/register/physicsSeal/paySuccess.vue'),
        hidden: true,
        meta: {
            title: '物理章申领',
            hidden: true
        },
    },
    {
        path: '/h5/home',
        component: () => import('@/pages/H5/home/index.vue'),
        hidden: true,
        meta: {
            title: '物理章申领',
            hidden: true
        },
    },
    {
        path: '/h5/physicsSeal/:id',
        name: 'physicsSeal',
        component: () => import('@/pages/H5/physicsSeal/index.vue'),
        hidden: true,
        meta: {
            title: '物理章申领',
            hidden: true
        },
    },
    {
        path: '/h5/authentication/:id',
        name: 'authentication',
        component: () => import('@/pages/H5/authentication/index.vue'),
        hidden: true,
        meta: {
            title: '认证',
            hidden: true
        },
    },
    {
        path: '/h5/operatorAuthentication',
        name: 'operatorAuthentication',
        component: () => import('@/pages/H5/operatorAuthentication/index.vue'),
        hidden: true,
        meta: {
            title: '经办人认证',
            hidden: true
        },
    },
    {
        path: '/digitalCertificate/:id',
        name: 'digitalCertificate',
        component: () => import('@/pages/digitalCertificate/index.vue'),
        hidden: true,
        meta: {
            title: '数字证书在线申请',
            hidden: true
        },
    },
    {
        path: '/register/sealChange',
        component: () => import('@/pages/register/sealChange.vue'),
        hidden: true,
        meta: {
            title: '印章申领种类选择',
            hidden: true
        },
    },
    {
        path: '/register/sealConfirm',
        component: () => import('@/pages/register/sealConfirm.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/register/officialConfirm',
        component: () => import('@/pages/register/officialConfirm.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/register/orderPay',
        component: () => import('@/pages/register/orderPay.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/register/orderPayOff',
        component: () => import('@/pages/register/orderPayOff.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/qys',
        component: () => import('@/pages/qys/register.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/qys/sealConfirm',
        component: () => import('@/pages/qys/sealConfirm.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/qys/officialConfirm',
        component: () => import('@/pages/qys/officialConfirm.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/qys/orderPay',
        component: () => import('@/pages/qys/orderPay.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/qys/orderPayOff',
        component: () => import('@/pages/qys/orderPayOff.vue'),
        hidden: true,
        meta: {
            title: '在线申领',
            hidden: true
        },
    },
    {
        path: '/home',
        component: Layout,
        children: [{
            path: "",
            component: () => import('@/pages/userCenter/userCenter'),
            meta: {
                title: "首页",
                hidden: false,
                activeName: '/home'
            }
        },
        ]
    },
    {
        path: '/userCenter',
        component: Layout,
        meta: {
            title: '用户中心',
            hidden: true,
        },
        children: [
            {
                path: "myPrivateSeal",
                component: () => import('@/pages/userCenter/myPrivateSeal'),
                meta: {
                    title: "用户中心",
                    hidden: true,
                    activeName: '/userCenter'
                }
            },
            {
                path: "customManage",
                component: () => import('@/pages/userCenter/customManage'),
                meta: {
                    title: "用户中心",
                    hidden: true,
                    activeName: '/userCenter'
                }
            },
            {
                path: "authorizationManage",
                component: () => import('@/pages/userCenter/authorizationManage.vue'),
                meta: {
                    title: "用户中心",
                    hidden: true,
                    activeName: '/userCenter'
                }
            },
            {
                path: "order",
                component: () => import('@/pages/userCenter/orderList.vue'),
                meta: {
                    title: "用户中心",
                    hidden: true,
                    activeName: '/userCenter'
                }
            },
            {
                path: "productCenter",
                component: () => import('@/pages/userCenter/productCenter.vue'),
                meta: {
                    title: "用户中心",
                    hidden: true,
                    activeName: '/userCenter'
                }
            },
        ]
    },
    {
        path: '/document',
        component: Layout,
        meta: {
            title: '签署记录',
        },
        children: [{
            path: "",
            component: () => import('@/pages/document/document'),
            meta: {
                title: "签署记录",
                hidden: false,
                activeName: '/document'
            }
        }]
    },
    {
        path: '/transfer/:id',
        name: 'transfer',
        component: () => import('@/pages/home/transfer.vue'),
        hidden: true,
    },
    {
        path: '/customerEnterprise/login',
        name: 'customerEnterpriseLogin',
        component: () => import('@/pages/customerEnterprise/login.vue'),
        hidden: true,
    },
    {
        path: '/customerEnterprise/physicsSeal',
        component: customerEnterpriseLayout,
        meta: {
            title: '物理订单列表',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/physicsSeal/orderList.vue'),
            meta: {
                title: "列表",
                hidden: false,
                activeName: '/home'
            }
        }],
        hidden: true,
    },
    {
        path: '/verifyTruth',
        name: 'verifyTruth',
        component: () => import('@/pages/verifyTruth/index.vue'),
        hidden: true,
    },
    {
        path: '/interfaceDocumentation',
        name: 'interfaceDocumentation',
        component: () => import('@/pages/interfaceDocumentation/index.vue'),
        hidden: true,
    },
    {
        path: '/customerEnterprise/findPassword',
        component: () => import('@/pages/customerEnterprise/findPassword/findPassword.vue'),
        hidden: true,
        meta: {
            title: '找回密码',
            hidden: true
        },
    },
    {
        path: '/customerEnterprise/home',
        component: customerEnterpriseLayout,
        meta: {
            title: '首页',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/home.vue'),
            meta: {
                title: "首页",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/list',
        component: customerEnterpriseLayout,
        meta: {
            title: '列表',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/list/list.vue'),
            meta: {
                title: "列表",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/orderList',
        component: customerEnterpriseLayout,
        meta: {
            title: '订单列表',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/orderList.vue'),
            meta: {
                title: "订单列表",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/record',
        component: customerEnterpriseLayout,
        meta: {
            title: '备案',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/record.vue'),
            meta: {
                title: "备案",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/authorization',
        component: customerEnterpriseLayout,
        meta: {
            title: '激活',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/authorization.vue'),
            meta: {
                title: "激活",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/invoiceOrderList',
        component: customerEnterpriseLayout,
        meta: {
            title: '发票',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/invoiceOrderList.vue'),
            meta: {
                title: "发票",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/customerService',
        component: customerEnterpriseLayout,
        meta: {
            title: '客户服务',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/customerService/index.vue'),
            meta: {
                title: "客户服务",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/productCenter',
        component: customerEnterpriseLayout,
        meta: {
            title: '商品中心',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/productCenter/list.vue'),
            meta: {
                title: "商品中心",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/customerEnterprise/department',
        component: customerEnterpriseLayout,
        meta: {
            title: '部门',
        },
        children: [{
            path: "",
            component: () => import('@/pages/customerEnterprise/department/index.vue'),
            meta: {
                title: "部门",
                hidden: false,
            }
        }]
    },
    {
        path: '/openness/home',
        component: opennessLayout,
        meta: {
            title: '列表',
        },
        children: [{
            path: "",
            component: () => import('@/pages/openness/home/index.vue'),
            meta: {
                title: "列表",
                hidden: false,
                activeName: '/home'
            }
        }]
    },
    {
        path: '/about',
        component: () => import('@/pages/About/Index.vue'),
        hidden: true,
    },
    {
        path: '/contactUs',
        component: () => import('@/pages/About/ContactUs.vue'),
        hidden: true,
    },
    {
        path: '*',
        redirect: '/error',
        hidden: true,
    },
]
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

const createRouter = () => new VueRouter({
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes,
    mode: 'hash'
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
